module.exports = __webpack_public_path__ + "static/media/office-tel-aviv.b63501d7.png";